<div class="container padding-bottom-3x mb-1">
    <div class="steps d-flex flex-nowrap justify-content-between padding-top-2x padding-bottom-1x">
        <div id="TransferPeriodActionReplace" class="step {{getActiveClass(TransferPeriodActionReplace)}}">
            <div class="step-icon-wrap">
                <div class="step-icon"><fa-icon [icon]=faExchangeAlt></fa-icon></div>
            </div>
            <h3 class="step-title">vervangen</h3>
        </div>
        <div id="TransferPeriodActionTransfer" class="step {{getActiveClass(TransferPeriodActionTransfer)}}">
            <div class="step-icon-wrap">
                <div class="step-icon"><fa-icon [icon]=faRightLeft></fa-icon></div>
            </div>
            <h3 class="step-title">transfers maken</h3>
        </div>
        <div id="TransferPeriodActionSubstitute" class="step {{getActiveClass(TransferPeriodActionSubstitute)}}">
            <div class="step-icon-wrap">
                <div class="step-icon"><fa-icon [icon]=faArrowsRotate></fa-icon></div>
            </div>
            <h3 class="step-title">wisselen</h3>
        </div>              
    </div>
      
</div>